// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const Blockquote = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <path d="M4.214 18h3.643l2.429-4.4V7H3v6.6h3.643L4.214 18zm9.715 0h3.642L20 13.6V7h-7.286v6.6h3.643L13.93 18z" />
  </svg>
);

export default Blockquote;
